import {effect, InputSignal, InputSignalWithTransform}                   from '@angular/core';
import {CaffType, CaffTypeDict, GlobalDataTypesDict, GlobalDictDataIntf} from '@djsharkk/logr-types';
import {IconName}                                                        from '@fortawesome/fontawesome-common-types';
import {TableRow}                                                        from './table-wrapper/table-wrapper.component';

export abstract class TableRowBase<T> {
	abstract row: InputSignal<TableRow>;
	abstract showDate: InputSignalWithTransform<boolean, unknown>;
	abstract detailed: InputSignalWithTransform<boolean, unknown>;


	getDataRow(): T {
		return this.row().data as T
	}

	rowIcon: IconName = 'spinner-third';

	constructor() {
		effect(() => {
			this.rowIcon = this.row().type === 'caff' ? CaffTypeDict[this.row().data.type as unknown as CaffType].icon : (GlobalDataTypesDict[this.row().type] as GlobalDictDataIntf<any>).icon;
		});
	}
}
